import {createRoot} from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import router from './router';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import type RequestError from '@errors/RequestError';
import config from '@config/index';
import {i18n} from '@lingui/core';
import {I18nProvider} from '@lingui/react';
import ServerError from '@errors/ServerError';
import {STATUS_TOO_MANY_REQUESTS} from '@constants/http';
import {SnackbarProvider} from 'notistack';
import {initTranslations} from '@i18n/i18n';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: (failureCount: number, error: RequestError | ServerError) =>
                failureCount < config.queryRetryCount &&
                (error instanceof ServerError || error.status === STATUS_TOO_MANY_REQUESTS),
            staleTime: 1000 * 20,
        },
    },
});

initTranslations();

createRoot(document.getElementById('root') as HTMLElement).render(
    <I18nProvider i18n={i18n}>
        <SnackbarProvider>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </SnackbarProvider>
    </I18nProvider>,
);
